import React from 'react';
import type { Thing, WithContext } from 'schema-dts';

export const JsonLd = <T extends Thing>({ data }: { data: WithContext<T> }) => (
  <script
    type="application/ld+json"
    dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
  />
);
